import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Smartphone, Loader2 } from 'lucide-react';

export function MobileAppLinksCard({ config, setConfig, onSave, saving }) {
  return (
    <Card className="border-border bg-card">
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2" style={{ fontFamily: 'Manrope' }}>
          <Smartphone className="w-5 h-5 text-blue-500" />
          Link App Mobile
        </CardTitle>
        <CardDescription>
          Configura i link per scaricare l'app mobile (visualizzati nella dashboard)
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label>Link App Store (iOS)</Label>
            <Input
              data-testid="app-store-link-input"
              type="url"
              placeholder="https://apps.apple.com/app/..."
              value={config?.app_store_url || ''}
              onChange={(e) => setConfig({ ...config, app_store_url: e.target.value })}
            />
          </div>
          <div className="space-y-2">
            <Label>Link Google Play (Android)</Label>
            <Input
              data-testid="play-store-link-input"
              type="url"
              placeholder="https://play.google.com/store/apps/..."
              value={config?.play_store_url || ''}
              onChange={(e) => setConfig({ ...config, play_store_url: e.target.value })}
            />
          </div>
        </div>
        <div className="flex justify-end">
          <Button 
            data-testid="save-mobile-links-btn"
            onClick={onSave} 
            disabled={saving}
          >
            {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
            Salva Link
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
